import { TAutocomplete } from './types';
import useCustomEvents from '../useCustomEvents';
import { TOwnEventHandlers } from '../useCustomEvents/types';

export default function useAutocompleteEvents(
  props: TAutocomplete,
  events: TOwnEventHandlers,
) {
  return useCustomEvents({
    component: 'input',
    name: props.name,
    disabled: props.disabled,

    ...events,

    parentOnBlur: props.onBlur,
    parentOnClick: props.onClick,
    parentOnFocus: props.onFocus,
    parentOnKeyDown: props.onKeyDown,
    parentOnKeyUp: props.onKeyUp,
    parentOnMouseDown: props.onMouseDown,
    parentOnMouseUp: props.onMouseUp,
  });
}
